import { render } from "./AccountChangeMode.vue?vue&type=template&id=99a21d28&ts=true"
import script from "./AccountChangeMode.vue?vue&type=script&lang=ts"
export * from "./AccountChangeMode.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__